import * as Actions from 'app/store/actions/users/users.actions';

const initialState = {
	status:[],
}

const usersReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_USERS_STATUS: {
			//console.log("GET_USERS_STATUS", action)
			return {
				...state,
				status: action.data
			};
		}
		case Actions.USERS_UPDATE_USER_STATUS: {
			//console.log("UPDATE_USER_STATUS", action)
			return {
				...state,
				status: action.data
			};
		}
		default:
			return state;
	}
};

export default usersReducer;
